<template>
  <div
    v-if="locales.length > 1"
    :class="[classDeclaration]"
    class="sf-lang-switcher"
    @click="changeLanguage">
    <div class="languages">
      <div
        v-for="locale in locales"
        :key="locale">
        {{ locale }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    locales() {
      return this.$lang.locales.map(l => l.code);
    },
    classDeclaration() {
      return this.index === 0 ? 'primary' : 'secondary';
    },
    index() {
      return this.locales.indexOf(this.$lang.locale);
    },
  },
  methods: {
    changeLanguage() {
      const next = this.index === 0 ? 1 : 0;
      this.$router.push(this.switchLocalePath(this.locales[next]));
    },
  },
};
</script>
